import { filterOnlyPitches } from './byResultTypes.js';
import { buildPitchPlayerFilters, buildPitchScoringFilters, buildPitchTaggingFilters } from './byContext.js';

const buildFiltersForPitchingChart = function({
    // tagging context 
    pitcherId, pitchResults, pitchTypes, pitchSet, zones, batterIds, batterHandedness,
    // scoring context
    outs, balls, strikes, runnersOn,
}) {
    let pitchingChartFilters = filterOnlyPitches();
    const taggingFilters = buildTaggingFiltersForPitchingChart({ pitcherId, pitchResults, pitchTypes, pitchSet, zones, batterIds, batterHandedness });
    if (taggingFilters instanceof Array){
        pitchingChartFilters = pitchingChartFilters.concat(taggingFilters);
    }

    const scoringFilters = buildPitchScoringFilters({ outs, balls, strikes, runnersOn });
    if (scoringFilters instanceof Array){
        pitchingChartFilters = pitchingChartFilters.concat(scoringFilters);
    }

    return pitchingChartFilters;
};

const buildTaggingFiltersForPitchingChart = function({
    pitcherId, pitchResults, pitchTypes, pitchSet, zones, batterIds, batterHandedness
}){
    let pitcherTagId = parseInt(pitcherId);
    if (pitcherTagId === 0 || isNaN(pitcherTagId)){
        throw new TypeError('pitcherId is required and should contain valid pitcher tag ID');
    }

    let pitchingChartFilters = buildPitchPlayerFilters([pitcherId], batterIds);
    pitchingChartFilters = pitchingChartFilters.concat(buildPitchTaggingFilters(
        { pitchResults, pitchTypes, pitchSet, zones, pitcherHandedness: '', batterHandedness}
    ));

    return pitchingChartFilters;
};

export default buildFiltersForPitchingChart;
export {
    buildFiltersForPitchingChart, buildTaggingFiltersForPitchingChart,
};